export enum State {
    Ready = 'ready',
    Absent = 'absent',
    Standby = 'standby',
}

export class TierState {
    static isPaused(state: State): boolean {
        return state === State.Absent || state === State.Standby;
    }

    static isReady(state: State): boolean {
        return state === State.Ready;
    }
}
